import Typography from "@mui/material/Typography";
import { ReactElement } from "react";
import useFullscreenControlState from "../MediaControl/useFullscreenControlState";
import { StaticMediaControls } from "./StaticMediaControls";

export type UseUnsupportedPreviewProps = {
  placeholder?: string;
  fullScreenMode?: boolean;
  onClickFullscreen?: () => void;
  onToggleFullscreenControl?: (toggle: boolean) => void;
};

export type UnsupportedPreviewState = {
  showFullscreenControl: boolean;
  toggleFullscreenControl: () => void;
};

export const useUnsupportedPreview = ({
  placeholder,
  fullScreenMode,
  onClickFullscreen,
  onToggleFullscreenControl,
}: UseUnsupportedPreviewProps): [ReactElement, ReactElement, UnsupportedPreviewState] => {
  const { showControl: showFullscreenControl, toggleControl: toggleFullscreenControl } =
    useFullscreenControlState({
      onChange: onToggleFullscreenControl,
    });

  const Preview = (
    <Typography variant="xxl" color="grey.400">
      {placeholder?.toLowerCase() || "Preview not supported"}
    </Typography>
  );

  const Controls = (
    <StaticMediaControls
      fullScreenMode={!!fullScreenMode}
      onClickFullscreen={() => {
        toggleFullscreenControl();
        onClickFullscreen?.();
      }}
    />
  );

  return [Preview, Controls, { showFullscreenControl, toggleFullscreenControl }];
};
